<template>
  <!--begin::List Widget 1-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0">
      <h3 class="card-title font-weight-bolder text-dark">Tasks Overview</h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2">
      <template v-for="(item, i) in list">
        <!--begin::Item-->
        <div class="d-flex align-items-center mb-10" v-bind:key="i">
          <!--begin::Symbol-->
          <div class="symbol symbol-40 symbol-light-primary mr-5">
            <span class="symbol-label">
              <span class="svg-icon svg-icon-lg" v-bind:class="item.style">
                <!--begin::Svg Icon-->
                <inline-svg :src="item.svg"></inline-svg>
                <!--end::Svg Icon-->
              </span>
            </span>
          </div>
          <!--end::Symbol-->
          <!--begin::Text-->
          <div class="d-flex flex-column font-weight-bold w-100">
            <a href="#" class="text-dark text-hover-primary mb-1 font-size-lg w-100 d-flex justify-content-between">
              {{ item.title }}
              <span>{{getCount(item)}}</span>
            </a>
            <span class="text-muted">
              {{ item.desc }}
            </span>
          </div>
          <!--end::Text-->
        </div>
        <!--end::Item-->
      </template>
    </div>
    <!--end::Body-->
  </div>
  <!--end: List Widget 1-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "widget-1",
  data() {
    return {
      list: [
        {
          title: "Delivery Person Count",
          desc: "Delivery Person Count",
          target: "userCount",
          svg: "media/svg/icons/Home/Library.svg",
          style: "svg-icon-primary",
        },
        {
          title: "Moment Count",
          desc: "Created moments",
          target: "momentCount",
          svg: "media/svg/icons/Home/Library.svg",
          style: "svg-icon-primary",
        },
        {
          title: "Media Count",
          desc: "Count of created moment media",
          target: "mediaCount",
          svg: "media/svg/icons/Home/Library.svg",
          style: "svg-icon-primary",
        },
        {
          title: "Media Size",
          desc: "Size of created moments media",
          target: "mediaSize",
          svg: "media/svg/icons/Home/Library.svg",
          style: "svg-icon-primary",
        },
      ],
    };
  },
  methods: {
    getCount(item) {
      if (item.target == "mediaSize") {
        return this.convertBytes(this[item.target]);
      } else {
        return this[item.target];
      }

    },
    convertBytes(bytes) {
      const megabytes = bytes / (1024 * 1024);
      return megabytes.toFixed(2) + " MB";
    },
  },
  computed: {
    ...mapGetters(["userCount", "momentCount", "mediaCount", "mediaSize"]),
  },
};
</script>
